import qs from "qs";
import { Http } from "./http.init";

export class BaseService {
  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static request() {
    return new Http(status);
  }

  static querystring(obj) {
    return qs.stringify(obj, {
      encode: false,
    });
  }
}
